import PortfolioSection from "./PortfolioSection";
import "@/App.css";
import { useEffect } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import { AIAssistantProvider } from "./context/AIAssistantContext";
import { Navbar } from "./components/Navbar";
import { Hero } from "./components/Hero";
import { Services } from "./components/Services";
import { AIAssistant } from "./components/AIAssistant";
import { Consultation } from "./components/Consultation";
import { Contact } from "./components/Contact";
import { Footer } from "./components/Footer";
import { FloatingAIButton } from "./components/FloatingAIButton";
import { AIAssistantModal } from "./components/AIAssistantModal";
import { PrivacyPolicy } from "./components/PrivacyPolicy";
import { CookieBanner } from "./components/CookieBanner";
import BusinessToolsSection from "./components/BusinessToolsSection";
import SiteNavigationFix from "./components/SiteNavigationFix";
import HideLegacyConvocoreSection from "./components/HideLegacyConvocoreSection";
import HideAssistantHeroSection from "./components/HideAssistantHeroSection";
import ProductsHomeSection from "./components/products/ProductsHomeSection";
import ProductsCatalog from "./components/products/ProductsCatalog";
import ProductDetailPage from "./components/products/ProductDetailPage";

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (!target) return;
    const t = setTimeout(() => {
      if (target === "home") {
        window.scrollTo({ top: 0, behavior: "smooth" });
      } else {
        const el = document.getElementById(target);
        if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      navigate(location.pathname, { replace: true, state: {} });
    }, 80);
    return () => clearTimeout(t);
  }, [location, navigate]);

  return (
    <main>
      <Hero />
      <Services />
      <ProductsHomeSection />
      <AIAssistant />
      <Consultation />
      <Contact />
      <SiteNavigationFix />
      <HideLegacyConvocoreSection />
      <HideAssistantHeroSection />
      <span id="workflows" style={{ position: "relative", top: "-90px" }} />
      <BusinessToolsSection />
      <PortfolioSection />
    </main>
  );
};

const Shell = () => (
  <div className="bg-[#09090b] text-white min-h-screen">
    <Navbar />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/productos" element={<ProductsCatalog />} />
      <Route path="/productos/:slug" element={<ProductDetailPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
    </Routes>
    <Footer />
    <FloatingAIButton />
    <AIAssistantModal />
    <CookieBanner />
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <AIAssistantProvider>
        <div className="App">
          <BrowserRouter>
            <Shell />
          </BrowserRouter>
        </div>
      </AIAssistantProvider>
    </LanguageProvider>
  );
}

export default App;
